// extracted by mini-css-extract-plugin
export default {"test":"test-rNvpZ","iconContainer":"iconContainer-EM3T5","icon":"icon-YmvT7"};